<template>
    <div class="badgebox-already-taken">
        <Badgebox :key="data.key">
            <p
                v-bastards
                class="fs-18 fs-lh-24 text-center text-bold"
                style="padding-top: 16px; padding-bottom: 16px;"
            >
                Jesteś już na liście! 
            </p>
            <p
                v-bastards
                class="fs-16 text-center"
            >
                Niestety, możesz otrzymać tylko jedną bezpłatną próbkę w tym miesiącu.
            </p>
        </Badgebox>
    </div>
</template>

<script>
import Badgebox from '@/components/badgebox/Badgebox'

export default {
    components: {
        Badgebox
    },

    props: {
        data: {
            type: Object,
            required: false,
            default: () => {}
        }
    }
}
</script>

<style>

</style>
